// extracted by mini-css-extract-plugin
export default {"container":"o8gEV0_twkwwG5Jml5WA__container___"};